import { escapeRegExpText } from 'features/aiWriter/AiWriterTextEditor/utils/escapeRegExpText';

export const boundedTextRegExp = (text: string) => {
  const safeText = escapeRegExpText(text);
  return new RegExp(`\\b${safeText}\\b`, 'igd');
};
